import { isLatLngLiteral } from '@vis.gl/react-google-maps';
import classNames from 'classnames';
import { useTranslation } from 'next-i18next';
import { Controller, useFormContext } from 'react-hook-form';

import { Typography } from '@/shared/components/atoms';
import { Map } from '@/shared/components/atoms/Map';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';

import GPS from '~/images/shared/GPS.svg';

interface Props {
  id: string;
  label?: string;
}

const GeoLocationPicker: React.FC<Props> = ({ id, label }) => {
  const { t } = useTranslation();

  const { openModal, closeModal } = useModal();

  const { control } = useFormContext();

  const getLatLngLiteral = (
    coordinates?: string | null
  ): google.maps.LatLngLiteral | undefined => {
    if (!coordinates || typeof coordinates !== 'string') return undefined;
    const latLng = coordinates.split(',');
    if (latLng.length < 2) return undefined;
    const latLngLiteral = {
      lat: Number(latLng[0]),
      lng: Number(latLng[1]),
    };
    return isLatLngLiteral(latLngLiteral) ? latLngLiteral : undefined;
  };

  return (
    <Controller
      name={id}
      control={control}
      render={({ field: { onChange, value } }) => (
        <div>
          {label && (
            <Typography className='mb-8' id={id}>
              {label}
            </Typography>
          )}
          <div
            className='flex cursor-pointer items-center justify-between rounded-xl border-xs border-outline-variant p-16'
            placeholder={t('Pin on map')}
            onClick={() =>
              openModal(
                <Map
                  location={getLatLngLiteral(value)}
                  handleSetLocation={(latLng) => {
                    onChange(`${latLng.lat},${latLng.lng}`);
                    closeModal();
                  }}
                />,
                { title: t('Click to drop pin') }
              )
            }
          >
            <Typography
              className={classNames(
                !isLatLngLiteral(getLatLngLiteral(value)) &&
                  'text-text-secondary'
              )}
            >
              {isLatLngLiteral(getLatLngLiteral(value))
                ? value
                : t('Pin location on map')}
            </Typography>
            <GPS width='24' height='24' />
          </div>
        </div>
      )}
    />
  );
};

export default GeoLocationPicker;
